import React, {useEffect, useState} from 'react';
import {
    Box, Button
} from "@chakra-ui/react";
import DesignData from "../../../resources/DesignTab/design_data.json";
import TechnologySection from "./TechnologySection";
import OtherSection from "./OtherSection";
import {FiArrowRight} from "react-icons/fi";
import {useParams} from "react-router-dom";
import {fetchDesignDetails, fetchProjectDetails, updateProjectStatus} from "./utils";
import {backendURL} from "../../../resources/values";

function getDefaultValue(field) {
    if (field.hasOwnProperty("defaultValue")) {
        return field.defaultValue;
    }
    if (field.inputType === "number")
        return 0.0;
    else
        return "";
}

function resetTechnology(technology) {
    const label = technology.label;
    const inputs = technology.inputs.map(input => ({
        ...input,
        value: getDefaultValue(input)
    }));
    return {
        label,
        inputs,
        isAdded: false,
    };
}


function getTechnologyData(itemsData) {
    const technologies = [...itemsData];

    return technologies.map(technology => {
        return resetTechnology(technology);
    });
}

function setInitialValues(fields) {
    return fields.map(field => {
        if (field.hasOwnProperty("items")) {
            const modifiedItems = field.items.map(item => ({...item, value: getDefaultValue(item)}));
            return {...field, items: modifiedItems};
        } else {
            return {...field, value: getDefaultValue(field)};
        }
    });
}

const DesignTab = ({setActiveTab}) => {
    const sections = DesignData['sections'];
    const [technologies, setTechnologies] = useState(getTechnologyData(DesignData["sections"][0]["items"]));
    const [financeFields, setFinanceFields] = useState(setInitialValues(sections[1].items));
    const [policyFields, setPolicyFields] = useState(setInitialValues(sections[2].items));
    const [clientSpecificFields, setClientSpecificFields] = useState(setInitialValues(sections[3].items));

    const {projectId} = useParams();

    const setDesignData = (designData) => {
        if (designData.hasOwnProperty("sections")) {
            const sectionData = designData.sections;
            if (sectionData.length === 4) {
                setTechnologies(sectionData[0].items);
                setFinanceFields(sectionData[1].items);
                setPolicyFields(sectionData[2].items);
                setClientSpecificFields(sectionData[3].items);
            }
        }
    }

    useEffect(() => {
        const fetchDetails = async () => {
            const designDetails = await fetchDesignDetails(projectId);
            if (designDetails)
                setDesignData(designDetails);
        }
        if (projectId) {
            fetchDetails();
        }
    }, []);

    const postData = async (projectId, designData) => {
        const url = `${backendURL}/projects/design/${projectId}/`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(designData)
            });

            if (response.ok) {
                const jsonResponse = await response.json();
                console.log('Data posted successfully:', jsonResponse);
                alert('Design data submitted successfully');
            } else {
                console.error('Failed to post data:', response.statusText);
                alert('Failed to post data:' + response.statusText);

            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const submitDesignData = () => {

        const designData = {
            "sections": [
                {
                    label: "Technologies",
                    items: technologies
                },
                {
                    label: "Finances",
                    items: financeFields
                },
                {
                    label: "Policy",
                    items: policyFields
                },
                {
                    label: "Client Specific Constraints",
                    items: clientSpecificFields
                }
            ]
        };

        postData(projectId, designData);
        updateProjectStatus(projectId, "draft").then();
    }
    return (
        <Box p={6} h={"100%"} overflowY={"auto"}>
            <TechnologySection label={"Technologies"} technologies={technologies} setTechnologies={setTechnologies}
                               resetTechnology={resetTechnology}/>
            <OtherSection label={"Finances"} fields={financeFields} setFields={setFinanceFields}/>
            <OtherSection label={"Policy"} fields={policyFields} setFields={setPolicyFields}/>
            <OtherSection label={"Client Specific Constraints"} fields={clientSpecificFields}
                          setFields={setClientSpecificFields}/>
            <Button
                position="absolute" right={4}
                bottom={4}
                rightIcon={<FiArrowRight/>}
                colorScheme="blue"
                onClick={() => {
                    submitDesignData();
                    setActiveTab(1)
                }}
            >
                View Summary
            </Button>
            {/*<Button*/}
            {/*    position="absolute" right={"1000px"}*/}
            {/*    bottom={4}*/}
            {/*    rightIcon={<FiArrowRight/>}*/}
            {/*    colorScheme="blue"*/}
            {/*    onClick={()=> {*/}
            {/*        submitDesignData();*/}
            {/*        setActiveTab(1)*/}
            {/*    }}*/}
            {/*>*/}
            {/*    Save*/}
            {/*</Button>*/}
        </Box>
    )
}


export default DesignTab;
